import { Component } from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ppg-product-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  standalone: true,
  imports: [Button],
  styleUrls: ['./warning-dialog.component.scss'],
})
export class WarningDialogComponent {
  data: {
    bodyContent: string;
    cancelText?: string;
    confirmText?: string;
  };

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.data = config.data;
  }

  closeDialog() {
    this.ref.close();
  }

  closeDialogWithConfirm() {
    this.ref.close(true);
  }
}
